import { AppThunk } from '../../../../../../store/types';
import { PlayerManager } from '../../../../../../effects/player/manager/playerManager';
import { getTargetCaptions } from '../../../../../../store/videos/selectors';

export class AudioCaptionsContainerEvents {

  public static onKeyDown(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
    }
  }

  public static onVideoChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
    }
  }

  public static onTargetCaptionsChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {
      PlayerManager.getInstance().setTargetCaptions(getTargetCaptions(getState()));
    }
  }

  public static onNativeCaptionsChange(): AppThunk {
    return (
      dispatch,
      getState
    ) => {

    }
  }

}
